import { render, staticRenderFns } from "./PictureCropper.vue?vue&type=template&id=1060796a&"
import script from "./PictureCropper.vue?vue&type=script&lang=js&"
export * from "./PictureCropper.vue?vue&type=script&lang=js&"
import style0 from "./PictureCropper.vue?vue&type=style&index=0&id=1060796a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports